import { takeLatest, select, put } from 'redux-saga/effects';

import { consts as createGuarantorConsts } from '../requests/create-guarantor-req';
import { consts as removeGuarantorConsts } from '../requests/remove-guarantor-req';
import { actions as guarantorsActions } from '../requests/guarantors-req';
import { selectProgressCareUserId } from '../../appointmentForm/selectors';
import { selectPaperworkAppointmentUserId } from '../../paperwork/selectors/paperwork-get-appointment-details';
import { PAPERWORK } from '../../../constants/routes';

export function* handleRefetchGuarantorsInformation() {
  const getCareUserId = yield select(selectProgressCareUserId);
  const paperworkUserId = yield select(selectPaperworkAppointmentUserId);

  const { pathname } = window.location;

  const userId = pathname.includes(PAPERWORK) ? paperworkUserId : getCareUserId;

  if (userId) {
    yield put(guarantorsActions.send({ userId }));
  }
}

export function* refetchGuarantorsInformation() {
  yield takeLatest(
    [removeGuarantorConsts.SUCCEED],
    handleRefetchGuarantorsInformation,
  );

  yield takeLatest(
    [createGuarantorConsts.SUCCEED],
    handleRefetchGuarantorsInformation,
  );
}



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/sagas/refetch-guarantors.js